import { render, staticRenderFns } from "./MergeAccountModal.vue?vue&type=template&id=486569b3&scoped=true&"
import script from "./MergeAccountModal.vue?vue&type=script&lang=ts&"
export * from "./MergeAccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./MergeAccountModal.vue?vue&type=style&index=0&id=486569b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486569b3",
  null
  
)

export default component.exports